const SocialLinks = {
  discord: "https://discord.gg/5wzuX9Vvj9",
  twitter: "https://twitter.com/Mighty_meta",
  iconSize: "40px",
};

export default SocialLinks;
